// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:a728b4b3-b312-4d6a-b2e7-c62c5869967a",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_ivkG62Fvc",
    "aws_user_pools_web_client_id": "22j4f32a2e0rf4q512ahpf135g",
    "oauth": {}
};


export default awsmobile;
